// extracted by mini-css-extract-plugin
module.exports = {"Item":"connect-wallet-item_Item__7zMsa","Light":"connect-wallet-item_Light__16opU","Dark":"connect-wallet-item_Dark__Rziew"};